import TheMask from "@/components/ext/the-mask/the-mask.vue";

export default {
  name: "text-input",
  data() {
    return {
      focused: false
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      default: null
    },
    mask: {
      type: String,
      default: ""
    },
    masked: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    input(a, b, c) {}
  },
  components: {
    TheMask
  }
};



// WEBPACK FOOTER //
// ./src/components/ext/input-text/input-text.js